"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const adyen_1 = require("../../helper/adyen");
const history_1 = require("../../helper/history");
const path_1 = require("../../helper/path");
const payment_1 = require("../../helper/payment");
const AdyenPaymentStatusStore_1 = __importDefault(require("../../stores/AdyenPaymentStatusStore"));
const ShopwareOrder_1 = __importDefault(require("../../stores/ShopwareOrder"));
const ShopwarePaymentMethods_1 = __importDefault(require("../../stores/ShopwarePaymentMethods"));
const ShopCheckoutLayout_1 = __importDefault(require("../ShopCheckoutLayout"));
const ShopCheckoutRadio_1 = __importDefault(require("../ShopCheckoutRadio"));
const ShopCheckoutPaySummary_1 = __importDefault(require("./ShopCheckoutPaySummary"));
class ShopCheckoutPayError extends react_1.default.Component {
    initialLoading = false;
    internalSelectedPaymentMethodId = null;
    order = null;
    paymentErrorMessage = null;
    submitting = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            initialLoading: mobx_1.observable,
            internalSelectedPaymentMethodId: mobx_1.observable,
            isAdyenPaymentMethod: mobx_1.computed,
            isButtonDisabled: mobx_1.computed,
            isLoading: mobx_1.computed,
            isPaymentMethodSelectDisabled: mobx_1.computed,
            paymentErrorMessage: mobx_1.observable,
            order: mobx_1.observable,
            orderId: mobx_1.computed,
            orderPaymentMethodId: mobx_1.computed,
            selectedPaymentMethodId: mobx_1.computed,
            submitting: mobx_1.observable,
        });
    }
    get orderId() {
        return this.props.match?.params?.orderId ?? null;
    }
    get isAdyenPaymentMethod() {
        return this.determineIsAdyenPaymentMethod(this.selectedPaymentMethodId);
    }
    get isButtonDisabled() {
        return this.isPaymentMethodSelectDisabled || !this.selectedPaymentMethodId;
    }
    get isPaymentMethodSelectDisabled() {
        return this.isLoading || this.submitting;
    }
    get isLoading() {
        return this.initialLoading;
    }
    get orderPaymentMethodId() {
        return this.order ? (0, payment_1.getOrderPaymentMethodId)(this.order) : null;
    }
    get selectedPaymentMethodId() {
        return this.internalSelectedPaymentMethodId ?? this.orderPaymentMethodId;
    }
    componentDidMount() {
        this.checkOrderState();
    }
    componentDidUpdate(prevProps) {
        if (this.orderId !== prevProps.match?.params?.orderId) {
            (0, mobx_1.runInAction)(() => {
                this.order = null;
            });
            this.checkOrderState();
        }
    }
    render() {
        return (react_1.default.createElement(ShopCheckoutLayout_1.default, { className: "znd-shop-checkout-payment-page", title: (0, translation_1.t)('shop_checkout_pay_error.page_title'), loading: this.isLoading, showSidebarMobile: true, summaryElement: react_1.default.createElement(ShopCheckoutPaySummary_1.default, { loading: this.isLoading, order: this.order }), submitElement: react_1.default.createElement(Button_1.default, { className: "znd-shop-checkout-summary__submit", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('shop_checkout_pay_error.submit', {
                    payment: this.isAdyenPaymentMethod ? 'required' : '',
                }), onClick: (0, mobx_1.action)(() => {
                    const orderId = this.orderId;
                    const paymentMethodId = this.selectedPaymentMethodId;
                    if (!orderId || !paymentMethodId) {
                        const error = (0, translation_1.t)('payment_errors.failed', { refusalReasonCode: '_unknown_' });
                        react_toastify_1.toast.error(error);
                        this.paymentErrorMessage = error;
                        return;
                    }
                    this.submitting = true;
                    ShopwareOrder_1.default.setPayment(orderId, paymentMethodId)
                        .then(() => {
                        if (!this.determineIsAdyenPaymentMethod(paymentMethodId)) {
                            const url = `${window.location.origin}${(0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_CONFIRMATION).replace(':orderId', orderId)}`;
                            window.location.replace(url);
                            return;
                        }
                        const url = `${window.location.origin}${(0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_PAY).replace(':orderId', orderId)}`;
                        window.location.replace(url);
                    })
                        .catch((0, mobx_1.action)(() => {
                        this.submitting = false;
                        const error = (0, translation_1.t)('payment_errors.failed', { refusalReasonCode: '_unknown_' });
                        react_toastify_1.toast.error(error);
                        this.paymentErrorMessage = error;
                    }));
                }), loading: this.isLoading || this.submitting, disabled: this.isPaymentMethodSelectDisabled }) }, this.isLoading ? (react_1.default.createElement("div", { className: "znd-shop-checkout-pay-content__loader" },
            react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement("div", { className: "znd-shop-checkout-payment-page__methods znd-shop-checkout-pay-error-content" },
            !!this.paymentErrorMessage ? (react_1.default.createElement("div", { className: "znd-shop-checkout-pay-error-content__error-information" },
                react_1.default.createElement("div", null, (0, translation_1.t)('shop_checkout_pay_error.error_info')),
                react_1.default.createElement("div", null, (0, translation_1.t)('shop_checkout_pay_error.error_reason', { message: this.paymentErrorMessage })))) : null,
            ShopwarePaymentMethods_1.default.validPaymentMethods.map((paymentMethod) => (react_1.default.createElement(ShopCheckoutRadio_1.default, { key: paymentMethod.id, groupName: "paymentMethod", checked: this.selectedPaymentMethodId === paymentMethod.id, selectableMethod: paymentMethod, disabled: this.isPaymentMethodSelectDisabled, onChange: (0, mobx_1.action)((methodId) => {
                    this.internalSelectedPaymentMethodId = methodId;
                    return Promise.resolve();
                }), additionalFieldsFullWidth: true })))))));
    }
    redirectToCart() {
        (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SHOP_CART);
    }
    determineIsAdyenPaymentMethod(paymentMethodId) {
        if (!paymentMethodId) {
            // As this page is shown upon a payment error, assume adyen is used as long as there is no payment method.
            return true;
        }
        const selectedMethod = ShopwarePaymentMethods_1.default.validPaymentMethods.find((method) => !!method?.id && method.id === paymentMethodId);
        // As this page is shown upon a payment error, assume adyen is used as long as there is no payment method.
        return !selectedMethod || (0, adyen_1.isAdyenPaymentMethod)(selectedMethod);
    }
    checkOrderState() {
        const orderId = this.orderId;
        if (!orderId) {
            react_toastify_1.toast.error((0, translation_1.t)('payment_errors.no_order'));
            return this.redirectToCart();
        }
        (0, mobx_1.runInAction)(() => {
            this.initialLoading = true;
            this.paymentErrorMessage = null;
        });
        Promise.all([
            ShopwareOrder_1.default.loadOrder(orderId).then((0, mobx_1.action)((order) => {
                this.order = order;
            })),
            AdyenPaymentStatusStore_1.default.loadPaymentStatus(orderId)
                .catch(noop_1.noop)
                .then((0, mobx_1.action)((status) => {
                const refusalReasonCode = status && status?.refusalReasonCode ? status?.refusalReasonCode : '_unknown_';
                const error = (0, translation_1.t)('payment_errors.failed', { refusalReasonCode });
                react_toastify_1.toast.error(error);
                this.paymentErrorMessage = error;
            })),
            ShopwarePaymentMethods_1.default.loadPaymentMethods(),
        ]).finally(() => {
            this.initialLoading = false;
        });
    }
}
__decorate([
    bind_decorator_1.default
], ShopCheckoutPayError.prototype, "redirectToCart", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPayError.prototype, "checkOrderState", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ShopCheckoutPayError));
